import React, { Component } from 'react';
import ReactDOM from "react-dom";
import PropTypes from 'prop-types';
import { AMP_EVENTS_SOURCES_READY } from './plugin.constants';
const { Promise, MutationObserver } = window;
class PluginComponent extends Component {
    constructor(props) {
        super(props);

        this.subscriptions = [];

        //console.log("[PluginComponent] props:", props, "\tstate:", this.state);
    }

    destroySubscriptions() {
        //console.log("[PluginComponent] Destroy subscriptions");
        this.subscriptions.forEach(source => {
            source.unsubscribe();
        })
        this.subscriptions = [];

    }

    
    componentDidMount() {
        //console.log("[PluginComponent] Mounted:", this.props.player);
        const { player: amp } = this.props;

        const init = (amp) => {
            amp.addEventListener('destroy', e => {
                ReactDOM.unmountComponentAtNode(this.props.container);
            })

            const ready = (amp) => {
                if (amp.AmpEventsSources == null) {
                    amp.addEventListener(AMP_EVENTS_SOURCES_READY, e => {
                        this.pluginComponentDidMount();
                    })
                } else {
                    this.pluginComponentDidMount();
                }
            }

            if (amp.playState == null) {
                amp.addEventListener('ready', e => {
                    ready(amp);
                });

            } else {
                ready(amp)
            }

        }

        // AKAMAI initially creates a 'video' insead of an 'audio' HTML Element 
        // and replaces it later in it's lifecycle
        if (amp.config.settings.medium === "audio" && amp.mediaElement.tagName !== "AUDIO") {
            let targetNode = amp.container.querySelector('.amp-video');
            if (targetNode == null) {
                targetNode = amp.container;
            }

            const OBSERVER_CONFIG = { attributes: false, childList: true, subtree: true };
            const callback = (mutationsList, observer) => {
                // Use traditional 'for loops' for IE 11
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        if (amp.mediaElement.tagName === "AUDIO") {
                            observer.disconnect();
                            init(amp);

                            
                        }
                    }
                }
            };
            const observer = new MutationObserver(callback);

            observer.observe(targetNode, OBSERVER_CONFIG);

        } else {
            init(amp);
            
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.shouldPluginComponentUpdate(nextProps, nextState);
    }
    componentDidUpdate(prevProps, prevState) {
        this.pluginComponentDidUpdate(prevProps, prevState);
    }
    componentWillUnmount() {
        //console.log("[PluginComponent] Unmount")
        this.destroySubscriptions();
        this.pluginComponentWillUnmount();
    }

    pluginComponentDidMount() {}
    shouldPluginComponentUpdate(nextProps, nextState) { return true; }
    pluginComponentDidUpdate(prevProps, prevState) {}
    pluginComponentWillUnmount() {}
    render() {

        return this.props.children;
    }

    static get containerClass() {
        return "plugin-component-container"
    }
    // DON'T DO AUDIO TAGNAME CHECK IN HERE
    // AMP WONT INITIALIZE IF THE PLUGIN DOESN'T RESPOND TO THE PROMISE
    static create(player, config, key) {
        //console.log("[PluginComponent] config:", config);
        const { containerClass } = this;
        const PluginElement = this;

        let container = document.createElement('div');
        let props = {
            player,
            config,
            container
        }
        let classes = containerClass.split(" ");
        classes.forEach(className => {
            container.classList.add(className);
        })

        player.container.appendChild(container);
        let plugin = React.createElement(PluginElement, props);
        ReactDOM.render(plugin, container);

        return Promise.resolve(plugin);
    }

    static get propTypes() {
        return {
            "player": PropTypes.object.isRequired,
            "config": PropTypes.object,
            children: PropTypes.array,
            container: PropTypes.element
        }
    }

    static get defaultProps() {
        return {
            "config": {}
        }
    }
}
export { AMP_EVENTS_SOURCES_READY }
export default PluginComponent